import { signIn, refresh } from '@/apps/auth/api'

export default {
  // Sign in
  signIn({ commit }, { emailPhone, password }) {
    return signIn(emailPhone, password).then(data => {
      commit('SET_TOKENS', data)
      return data
    })
  },
  // Sign out
  signOut({ commit }) {
    commit('DELETE_TOKENS')
    return Promise.resolve(true)
  },
  // Refresh tokens
  refresh({ commit, dispatch, getters, state }) {
    if (state.refreshingCall) {
      return state.refreshingCall
    }
    const refreshingCall = refresh(state.accessToken, state.refreshToken).then(
      data => {
        commit('SET_TOKENS', data)
        commit('SET_REFRESHING_CALL', null)
        return Promise.resolve(data.access)
      }
    )
    commit('SET_REFRESHING_CALL', refreshingCall)
    return refreshingCall
  }
}



// WEBPACK FOOTER //
// ./src/apps/auth/store/actions.js